import "./column-components.b2a20dc1.js";
import {Component as $cYVqh$Component} from "react";
import $cYVqh$macrostrathyper from "@macrostrat/hyper";
import $cYVqh$uiwreactcolorswatch from "@uiw/react-color-swatch";
import {Popover as $cYVqh$Popover} from "@blueprintjs/core";


function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirea149"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirea149"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
var $9abdb902e1f016ec$exports = {};

$parcel$export($9abdb902e1f016ec$exports, "BasicFaciesSwatch", () => $9abdb902e1f016ec$export$601edd34af742364);
$parcel$export($9abdb902e1f016ec$exports, "FaciesSwatch", () => $9abdb902e1f016ec$export$a3eca1b02e3b1d92);





var $aVUB5 = parcelRequire("aVUB5");
class $9abdb902e1f016ec$var$FaciesColorPicker extends (0, $cYVqh$Component) {
    static #_ = this.contextType = (0, $aVUB5.FaciesContext);
    render() {
        const { setFaciesColor: setFaciesColor } = this.context;
        const { facies: d } = this.props;
        return (0, $cYVqh$macrostrathyper)("div", [
            (0, $cYVqh$macrostrathyper)((0, $cYVqh$uiwreactcolorswatch), {
                color: d.color || "black",
                onChange (color) {
                    return setFaciesColor(d.id, color.hex);
                }
            })
        ]);
    }
}
const $9abdb902e1f016ec$export$601edd34af742364 = ({ facies: d, ...rest })=>(0, $cYVqh$macrostrathyper)("div.color-swatch", {
        style: {
            backgroundColor: d.color || "black",
            width: "2em",
            height: "2em"
        },
        ...rest
    });
class $9abdb902e1f016ec$export$a3eca1b02e3b1d92 extends (0, $cYVqh$Component) {
    static #_ = this.defaultProps = {
        isEditable: true,
        facies: null
    };
    constructor(props){
        super(props);
    }
    render() {
        const { facies: facies, isEditable: isEditable } = this.props;
        const basic = (0, $cYVqh$macrostrathyper)($9abdb902e1f016ec$export$601edd34af742364, {
            facies: facies
        });
        if (!isEditable) return basic;
        return (0, $cYVqh$macrostrathyper)((0, $cYVqh$Popover), {
        }, [
            basic,
            (0, $cYVqh$macrostrathyper)($9abdb902e1f016ec$var$FaciesColorPicker, {
                facies: facies
            })
        ]);
    }
}


export {$9abdb902e1f016ec$export$601edd34af742364 as BasicFaciesSwatch, $9abdb902e1f016ec$export$a3eca1b02e3b1d92 as FaciesSwatch};
//# sourceMappingURL=column-components.27aee089.js.map
